import { useTranslation } from 'react-i18next';
import { Grid, MultiSelect, NumberInput } from '@mantine/core';
import FormHeading from 'apps/Projects/SamplePlans/FormInputs/FormHeading';

import InputAndLabelGridRow from 'common/Components/InputAndLabelGridRow';

import { useProjectsTranslations } from '../hooks';
import { useSamplePlanFormContext } from '../samplePlanFormContextV2';

import { useCarbonPlanConfigQuery } from './queries';

const ExclusionLayerDetails = () => {
  const { t } = useTranslation();
  const translations = useProjectsTranslations();

  const samplePlanForm = useSamplePlanFormContext();

  const { samplePlanConfig } = useCarbonPlanConfigQuery();

  return (
    <>
      <FormHeading text={translations.exclusionLayers} mb="xs" />
      <Grid>
        <InputAndLabelGridRow
          elemId="exclusion-layers-select"
          label={translations.exclusionLayersMultiSelect}
          span={5}
          input={
            <MultiSelect
              data={samplePlanConfig?.exclusion_layers.map((layer) => ({
                value: layer,
                label: t(layer),
              }))}
              id="exclusion-layers-select"
              {...samplePlanForm.getInputProps('exclusion_layers')}
            />
          }
        />
        <InputAndLabelGridRow
          elemId="exclusion-layers-tree-shrub"
          label={translations.treeAndShrubCover}
          span={5}
          input={
            <NumberInput
              suffix="%"
              mb="md"
              w="10rem"
              min={0}
              max={100}
              {...samplePlanForm.getInputProps('tree_shrub')}
            />
          }
        />
        <InputAndLabelGridRow
          elemId="exclusion-layers-steep-slope"
          label={translations.steepSlope}
          span={5}
          input={
            <NumberInput
              suffix="%"
              mb="md"
              w="10rem"
              min={0}
              max={100}
              {...samplePlanForm.getInputProps('slope')}
            />
          }
        />
      </Grid>
    </>
  );
};

export default ExclusionLayerDetails;
